




































































































































































































































import { Component, Emit, Prop, Watch } from 'nuxt-property-decorator'
import { orderBy, reject, some } from 'lodash'
import DataTable from '@/components/molecules/DataTable/DataTable.vue'
import {
  Col,
  findSortColumnItem,
  setSortOrder,
  SortColumn
} from '@/components/molecules/DataTable'
import { LendCollection, SystemCode } from '@/api'
import {
  BibliographyDetailRealTabType,
  BibliographyDetailSetTabType,
  CollectionFlag,
  Prefix,
  SearchType,
  SortOrder
} from '@/types'
import { PAGE_LEND_RESET } from '@/config/event'
import IconBibliography from '@/components/molecules/IconBibliography/IconBibliography.vue'
import RecycleScroller from '@/components/molecules/RecycleScroller/RecycleScroller.vue'
import { systemParameterStore } from '@/utils/store-accessor'

@Component({
  components: {
    RecycleScroller,
    IconBibliography,
    DataTable
  }
})
export default class LendOutCollectionTable extends DataTable {
  @Prop({
    type: Array
  })
  items!: LendCollection[]

  @Prop({
    type: Array,
    default: () => []
  })
  checkedCollectionIds!: string[]

  @Prop({
    type: Boolean,
    default: false
  })
  isAllSelect!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  disabledCheckBox!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  isCheckBox!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  dialog!: boolean

  @Prop({
    type: Boolean,
    default: true
  })
  isTitleLink!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  lendAppendix!: boolean

  sortName: string = ''

  sortOrder: SortOrder = ''

  get showCols(): Col[] {
    const cols: Col[] = [
      {
        width: 26,
        items: [
          {
            name: 'check',
            align: 'center'
          }
        ]
      },
      {
        width: 50,
        items: [
          {
            name: 'no',
            align: 'right'
          }
        ]
      },
      {
        width: '15',
        resizable: true,
        movable: true,
        items: [
          {
            name: 'displayTitle',
            headerText: 'タイトル',
            sortable: true,
            sortOrder: ''
          }
        ]
      },
      {
        width: '5',
        resizable: true,
        movable: true,
        items: [
          {
            name: 'appendixCode',
            headerText: '付録',
            sortable: true,
            sortOrder: ''
          }
        ]
      },
      {
        width: '8',
        resizable: true,
        movable: true,
        items: [
          {
            name: 'lendTime',
            headerText: '貸出日',
            sortable: true,
            sortOrder: ''
          }
        ]
      },
      {
        width: '8',
        resizable: true,
        movable: true,
        items: [
          {
            name: 'collectionType',
            headerText: '資料区分',
            sortable: true,
            sortOrder: ''
          }
        ]
      },
      {
        width: '8',
        resizable: true,
        movable: true,
        items: [
          {
            name: 'shelfType',
            headerText: '配架区分',
            sortable: true,
            sortOrder: ''
          }
        ]
      },
      {
        width: '9',
        resizable: true,
        movable: true,
        items: [
          {
            name: 'collectionNo',
            headerText: '資料番号',
            sortable: true,
            sortOrder: ''
          }
        ]
      },
      {
        width: '8',
        resizable: true,
        movable: true,
        items: [
          {
            name: 'ndc',
            headerText: '請求分類',
            sortable: true,
            sortOrder: ''
          }
        ]
      },
      {
        width: '5',
        resizable: true,
        movable: true,
        items: [
          {
            name: 'branch',
            headerText: '貸出',
            sortable: true,
            sortOrder: ''
          }
        ]
      },
      {
        width: '5',
        resizable: true,
        movable: true,
        items: [
          {
            name: 'reserveCount',
            headerText: '予約',
            sortable: true,
            sortOrder: ''
          }
        ]
      },
      {
        width: '10',
        resizable: true,
        movable: true,
        items: [
          {
            name: 'dueDate',
            headerText: '返却予定日',
            sortable: true,
            sortOrder: ''
          }
        ]
      },
      {
        width: '5',
        resizable: true,
        movable: true,
        items: [
          {
            name: 'extendCount',
            headerText: '延長',
            align: 'right',
            sortable: true,
            sortOrder: ''
          }
        ]
      },
      {
        width: '5',
        resizable: true,
        movable: true,
        items: [
          {
            name: 'remindCount',
            headerText: '督促',
            align: 'right',
            sortable: true,
            sortOrder: ''
          }
        ]
      },
      {
        width: '9',
        resizable: true,
        movable: true,
        items: [
          {
            name: 'message',
            headerText: 'メッセージ',
            sortable: true,
            sortOrder: ''
          }
        ]
      }
    ]

    if (systemParameterStore.isPriorityDisplayHandlingTypeLendOutTab) {
      cols.forEach(col => {
        const firstColItem = col.items[0]

        if (
          firstColItem.name === 'shelfType' &&
          firstColItem.headerText === '配架区分'
        ) {
          firstColItem.name = 'handlingType'
          firstColItem.headerText = '取扱区分'
        }
      })
    }

    if (this.isCheckBox) {
      return cols
    }

    return reject<Col>(cols, col => some(col.items, ['name', 'check']))
  }

  get sortedItems(): LendCollection[] {
    if (this.sortName) {
      return orderBy<LendCollection>(
        this.items,
        (item: LendCollection) => {
          if (this.sortName === 'displayTitle') {
            return item.displayTitle + item.displayAuthor
          }

          const propertyValue = item[this.sortName as keyof LendCollection]
          const type: string = Object.prototype.toString
            .call(propertyValue)
            .slice(8, -1)
            .toLowerCase()

          if (type === 'object') return (propertyValue as SystemCode).shortName

          return propertyValue
        },
        this.sortOrder as 'asc' | 'desc'[]
      )
    }

    return this.items
  }

  @Watch('dialog')
  initializeSort(): void {
    if (this.dialog) return

    this.onSort({
      name: '',
      order: ''
    })
  }

  activated() {
    this.$eventBus.on(PAGE_LEND_RESET, this.initializeDataProperty)
  }

  deactivated() {
    this.$eventBus.off(PAGE_LEND_RESET)
  }

  initializeDataProperty(): void {
    this.sortName = ''
    this.sortOrder = ''
  }

  isSearchTypeMagazine(code: string): boolean {
    return code === SearchType.Magazine
  }

  isStringNumber(str: string): boolean {
    return !isNaN(Number(str))
  }

  isCollectionFlagCollection(collectionFlag: CollectionFlag): boolean {
    return collectionFlag === CollectionFlag.Collection
  }

  onClickTableRow(index: number) {
    if (this.isCheckBox && !this.disabledCheckBox) {
      this.onChangeCheckedCollectionIds(this.sortedItems[index].id)
    }
  }

  onSort(sortColumn: SortColumn) {
    setSortOrder(this.showCols, sortColumn)

    const sortColItem = findSortColumnItem(this.showCols)

    this.sortName = sortColItem?.name ?? ''
    this.sortOrder = sortColItem?.sortOrder ?? ''
  }

  // ここから資料照会ダイアログ
  openModalBibliographyDetail(
    prefix: Prefix,
    bibliographyId: number,
    bibliographyContentId?: number
  ) {
    if (prefix === Prefix.Set) {
      this.openModalBibliographyDetailSet(
        bibliographyId,
        BibliographyDetailSetTabType.Volume
      )
      return
    }
    this.openModalBibliographyDetailReal(
      bibliographyId,
      BibliographyDetailRealTabType.Collection,
      bibliographyContentId
    )
  }

  openModalBibliographyDetailReal(
    bibliographyRealId: number,
    tabType: BibliographyDetailRealTabType,
    bibliographyContentId?: number
  ) {
    this.$modalBibliographyDetailReal.open({
      bibliographyRealId,
      isBibliographySelectProcess: false,
      tabType,
      bibliographyContentId,
      onToggleSet: (
        bibliographyId: number,
        tabType: BibliographyDetailRealTabType
      ) => {
        this.openModalBibliographyDetailSet(bibliographyId, tabType)
      }
    })
  }

  openModalBibliographyDetailSet(
    bibliographySetId: number,
    tabType: BibliographyDetailSetTabType
  ) {
    this.$modalBibliographyDetailSet.open({
      bibliographySetId,
      isBibliographySelectProcess: false,
      tabType,
      onToggleReal: (
        bibliographyId: number,
        tabType: BibliographyDetailRealTabType
      ) => {
        this.openModalBibliographyDetailReal(bibliographyId, tabType)
      }
    })
  }
  // ここまで資料照会

  @Emit('change:appendix-lend')
  onChangeAppendixLendCheckbox(index: number): number {
    // クリックした時にチェックを切り替えさせない為に下記の処理を施している
    this.sortedItems[index].appendixLendFlag = !this.sortedItems[index]
      .appendixLendFlag

    this.$nextTick(
      () =>
        (this.sortedItems[index].appendixLendFlag = !this.sortedItems[index]
          .appendixLendFlag)
    )

    return this.items.findIndex(item => item.id === this.sortedItems[index].id)
  }

  @Emit('all-select')
  onClickAllSelect(): void {}

  @Emit('collection-ids')
  onChangeCheckedCollectionIds(collectionId: number): number {
    return collectionId
  }
}
